$(function () {

    // 图片懒加载功能 - 使用 Intersection Observer API
    if ('IntersectionObserver' in window) {
        var imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var img = entry.target;
                    var src = img.getAttribute('data-src');
                    
                    if (src) {
                        img.src = src;
                        img.onload = function() {
                            img.classList.remove('lazyload');
                            img.classList.add('loaded');
                        };
                        img.removeAttribute('data-src');
                        imageObserver.unobserve(img);
                    }
                }
            });
        }, {
            rootMargin: '50px 0px',
            threshold: 0.01
        });

        // 观察所有带有 lazyload 类的图片
        var lazyImages = document.querySelectorAll('img.lazyload');
        lazyImages.forEach(function(img) {
            imageObserver.observe(img);
        });
    } else {
        // 不支持 Intersection Observer 的浏览器回退方案
        var lazyImages = document.querySelectorAll('img.lazyload');
        lazyImages.forEach(function(img) {
            var src = img.getAttribute('data-src');
            if (src) {
                img.src = src;
                img.classList.remove('lazyload');
                img.classList.add('loaded');
            }
        });
    }

    resize();
    $(window).resize(function (event) {
        resize();
    });
    font();
    $(".modal_cont .close").click(function () { $(this).parents(".modal").stop().fadeOut() })
    $(".ul_tag li").click(function () { 
        var $li = $(this);
        var checkboxId = $li.data('checkbox');
        if (checkboxId) {
            var $checkbox = $('#' + checkboxId);
            $checkbox.prop('checked', !$checkbox.prop('checked'));
        }
        $(this).toggleClass("on"); 
    })
    
    // 表单验证功能
    $('#submitBtn').click(function(e) {
        e.preventDefault();
        
        var isValid = true;
        
        // 清除之前的晃动动画
        $('.m_input').removeClass('shake');
        $('.check_list li').removeClass('shake');
        
        // 验证邮箱
        var email = $('#emailInput').val().trim();
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        if (!email || !emailRegex.test(email)) {
            isValid = false;
            var $emailInput = $('.m_input');
            $emailInput.addClass('shake');
            
            // 移除shake类以便可以再次触发动画
            setTimeout(function() {
                $emailInput.removeClass('shake');
            }, 500);
        }
        
        // 验证复选框
        var checkboxes = ['checkbox1', 'checkbox2', 'checkbox3', 'checkbox4', 'checkbox5'];
        var uncheckedItems = [];
        
        checkboxes.forEach(function(id) {
            var $checkbox = $('#' + id);
            var $li = $checkbox.closest('li');
            
            if (!$checkbox.prop('checked')) {
                isValid = false;
                uncheckedItems.push($li);
            }
        });
        
        // 对未勾选的复选框添加晃动动画
        if (uncheckedItems.length > 0) {
            uncheckedItems.forEach(function($li) {
                $li.addClass('shake');
                setTimeout(function() {
                    $li.removeClass('shake');
                }, 500);
            });
        }
        
        // 如果所有验证通过，调用接口提交邮箱
        if (isValid) {
            // 显示加载状态
            var $submitBtn = $('#submitBtn');
            var originalText = $submitBtn.html();
            $submitBtn.html('SUBMITTING...').addClass('disabled');
            $submitBtn.css('pointer-events', 'none');
            
            // 调用接口提交邮箱
            fetch('https://user.supcase.com/prod-api/supcase/ttChallenge', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email
                })
            })
            .then(function(response) {
                if (response.ok) {
                    // 接口调用成功，跳转到下载页面
                    window.location.href = '/pages/tiktok-download';
                } else {
                    throw new Error('API call failed');
                }
            })
            .catch(function(error) {
                // 接口调用失败，恢复按钮状态并提示用户
                console.error('Submission failed:', error);
                $submitBtn.html(originalText).removeClass('disabled');
                $submitBtn.css('pointer-events', 'auto');
                alert('Submission failed, please try again later');
            });
        }
    });
    
    document.body.addEventListener('touchstart', function () { });
    var swiper1 = new Swiper('#headerSwiper', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
        navigation: {
            nextEl: '.header_swiper_prev',
            prevEl: '.header_swiper_next',
        },
    });
    var swiper2 = new Swiper('#proSwiper', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true, slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
            nextEl: '.pro_prev',
            prevEl: '.pro_next',
        },
    });
    var swiper3 = new Swiper('#proSwiper2', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true, slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
            nextEl: '.pro_prev2',
            prevEl: '.pro_next2',
        },
    });

    // 将Swiper实例保存到全局变量以便访问
    window.swiperInstances = {
        swiper1: swiper1,
        swiper2: swiper2,
        swiper3: swiper3
    };

    // 全局变量：跟踪当前播放的视频元素
    window.currentPlayingVideo = null;

    // 停止所有正在播放的视频
    function stopAllVideos() {
        $('.video-container').each(function() {
            var $container = $(this);
            var $imgBox = $container.find('.img');
            var $video = $imgBox.find('video');
            var $img = $imgBox.find('img');
            var $playBtn = $container.find('.play');

            // 如果有视频元素，移除它
            if ($video.length > 0) {
                $video.remove();
            }

            // 显示图片和播放按钮
            $img.show();
            $playBtn.show();

            // 重置videoLoaded标志
            $container.data('video-loaded', false);
        });
        
        // 清除当前播放视频的引用
        window.currentPlayingVideo = null;
    }

    // 为swiper2和swiper3添加slide切换事件监听器
    swiper2.on('slideChangeTransitionEnd', function() {
        resetAllSlides(swiper2);
    });

    swiper3.on('slideChangeTransitionEnd', function() {
        resetAllSlides(swiper3);
    });

    // 重置所有slides的视频状态为初始图片（除了当前激活的）
    function resetAllSlides(swiper) {
        var $wrapper = $(swiper.$el);
        var $slides = $wrapper.find('.swiper-slide');
        var activeIndex = swiper.activeIndex;

        $slides.each(function() {
            var $slide = $(this);
            var slideIndex = $slide.index();
            
            // 跳过当前激活的slide，不重置它
            if (slideIndex === activeIndex) {
                return;
            }

            var $container = $slide.find('.video-container');
            
            if ($container.length > 0) {
                var $imgBox = $container.find('.img');
                var $video = $imgBox.find('video');
                var $img = $imgBox.find('img');
                var $playBtn = $container.find('.play');

                // 如果有视频元素，移除它
                if ($video.length > 0) {
                    $video.remove();
                }

                // 显示图片和播放按钮
                $img.show();
                $playBtn.show();

                // 重置videoLoaded标志
                $container.data('video-loaded', false);
            }
        });
    }

    // 视频播放功能实现
    $('.video-container').each(function() {
        var $container = $(this);
        var $imgBox = $container.find('.img');
        var $playBtn = $container.find('.play');
        var videoUrl = $container.data('video-url');
        var videoPoster = $container.data('video-poster');

        // 点击播放按钮时加载并播放视频
        $playBtn.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            // 先停止所有正在播放的视频
            stopAllVideos();

            // 找到该slide所在的Swiper实例
            var $slide = $container.closest('.swiper-slide');
            var swiperContainer = $slide.closest('.swiper-container');
            var swiperId = swiperContainer.attr('id');
            var swiper = null;

            // 根据容器ID找到对应的Swiper实例
            if (swiperId === 'proSwiper') {
                swiper = window.swiperInstances.swiper2;
            } else if (swiperId === 'proSwiper2') {
                swiper = window.swiperInstances.swiper3;
            }

            // 如果找到Swiper实例，将该slide移动到中间
            if (swiper) {
                var slideIndex = $slide.index();
                swiper.slideTo(slideIndex);
            }

            // 检查视频是否已经加载过
            var videoLoaded = $container.data('video-loaded') || false;

            // 如果视频已经加载过，直接播放
            if (videoLoaded) {
                var $video = $imgBox.find('video');
                if ($video.length > 0) {
                    // 先暂停所有Swiper自动滚动，然后再播放视频
                    if (window.swiperInstances) {
                        Object.values(window.swiperInstances).forEach(function(swiper) {
                            if (swiper && swiper.autoplay) {
                                swiper.autoplay.stop();
                            }
                        });
                    }
                    $video[0].play();
                    // 设置当前播放的视频
                    window.currentPlayingVideo = $video[0];
                }
                return;
            }

            // 创建video元素
            var $video = $('<video>', {
                src: videoUrl,
                poster: videoPoster,
                controls: true,
                loop: true,
                muted: false,
                playsinline: true
            });

            // 替换图片为视频
            var $img = $imgBox.find('img');
            $img.hide();
            $video.insertBefore($img);
            $playBtn.hide();

            // 视频播放时暂停所有Swiper自动滚动
            $video.on('play', function() {
                console.log('视频开始播放，暂停自动滚动');
                // 设置当前播放的视频
                window.currentPlayingVideo = this;
                if (window.swiperInstances) {
                    Object.values(window.swiperInstances).forEach(function(swiper) {
                        if (swiper && swiper.autoplay) {
                            swiper.autoplay.stop();
                        }
                    });
                }
            });

            // 视频暂停时恢复所有Swiper自动滚动
            $video.on('pause', function() {
                console.log('视频暂停，恢复自动滚动');
                if (window.swiperInstances) {
                    Object.values(window.swiperInstances).forEach(function(swiper) {
                        if (swiper && swiper.autoplay) {
                            swiper.autoplay.start();
                        }
                    });
                }
            });

            // 视频结束时恢复所有Swiper自动滚动（注意：loop模式下不会触发）
            $video.on('ended', function() {
                console.log('视频播放结束，恢复自动滚动');
                if (window.swiperInstances) {
                    Object.values(window.swiperInstances).forEach(function(swiper) {
                        if (swiper && swiper.autoplay) {
                            swiper.autoplay.start();
                        }
                    });
                }
            });

            // 先暂停所有Swiper自动滚动，然后再播放视频
            if (window.swiperInstances) {
                Object.values(window.swiperInstances).forEach(function(swiper) {
                    if (swiper && swiper.autoplay) {
                        swiper.autoplay.stop();
                    }
                });
            }

            // 播放视频
            $video[0].play().catch(function(error) {
                console.log('视频播放失败:', error);
            });

            // 标记视频已加载
            $container.data('video-loaded', true);
        });
    });
});

/*main*/
//

function font() {
    var sw = $("body,html").width();
    var pw = 3840;
    if ($("body,html").width() > 1366) pw = 3840
    if ($("body,html").width() < 1366 && $("body,html").width() > 1024) pw = 2880
    if ($("body,html").width() < 1024 && $("body,html").width() > 767) pw = 1920
    if ($("body,html").width() < 767) pw = 2880
    var f = 100 * sw / pw;
    $('html').css('font-size', f + 'px');
}


/*call*/
//
function resize() {
    var ht = $(window).height();
    font();
} 